import { create } from 'zustand'
import { Visualization } from '~map-preview/types/__generated/gql/graphql'

export const VISUALIZATION_TYPES = {
  marker: 'marker',
  heatmap: 'heatmap',
  category: 'category',
  aggregate: 'aggregate',
  hexagon: 'hexagon'
}

interface MapToolbarState {
  visualization: Visualization
  setVisualization: (data: Visualization) => void
}

export const useMapToolbarStore = create<MapToolbarState>((set) => ({
  visualization: {},

  // Set the active map layer
  setVisualization: (data) => set(() => ({ visualization: data }))
}))
